import { Component, inject } from "@angular/core";
import { NavigationEnd, Router, RouterOutlet } from "@angular/router";
import { filter, map, startWith } from "rxjs/operators";
import { AsyncPipe } from "@angular/common";
import { WebSocketsService } from "./shared/services/web-sockets.service";
import { AiBookingFloatingWidgetComponent } from "./shared/components/ai-booking-floating-widget/ai-booking-floating-widget.component";

@Component({
  selector: "app-root",
  imports: [RouterOutlet, AiBookingFloatingWidgetComponent, AsyncPipe],
  templateUrl: "./app.component.html",
  styleUrl: "./app.component.scss",
})
export class AppComponent {
  title = "gloget";

  isAuthenticated = false;
  locationQuery = "";

  private router = inject(Router);

  showBookingWidget$ = this.router.events.pipe(
    filter((event): event is NavigationEnd => event instanceof NavigationEnd),
    map(() => this.router.url.startsWith("/customer")),
    startWith(this.router.url.startsWith("/customer")),
  );

  constructor(private wsService: WebSocketsService) {}

  // ngOnInit() {
  //   this.wsService.connect("ws://localhost:8000/ws/notifications/");
  // }
}
